import {CommonStatus} from "@/enums/status";
import {FreightServiceType} from "@/enums/type";

export class FreightServiceParams {
    page? = 1;
    limit? = 200;
    search?: string;
    type? = FreightServiceType.NORMAL;
    status? = CommonStatus.Active;
    postOfficeRowGuid?: string;
}